
































































import AppTableRow from "@/components/table/AppTableRow.vue";
import { EventBus } from "@/eventbus";
import Vue from "vue";
import CsvFilterParamCmp from "./CsvFilterParamCmp.vue";
export default Vue.extend({
  components: { CsvFilterParamCmp, AppTableRow },
  props: ["source"],
  setup(props) {
    const showMenu = (event: MouseEvent) => {
      EventBus.emit("ShowCsvReportMenu", { item: props.source, event });
    };

    return {
      showMenu,
    };
  },
});
